(function($){
  var sumoSelect = {
    init: function(){
      if ($('.sumoselect').length){
        sumoSelect.initSumoSelect();
      }
    },
    initSumoSelect: function() {
      $('.sumoselect').each(function(i,o) {
        $(o).SumoSelect({
          captionFormatAllSelected: null,
          captionFormat: $(o).data('sumo-captionformat'),
          // placeholder: $(o).data('sumo-placeholder')
        });
      });
    },
  };
  $(document).ready(sumoSelect.init);
})(jQuery);
